var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.3403 -0.000213623H5.67031C2.28031 -0.000213623 0.000305176 2.37979 0.000305176 5.91979V14.0898C0.000305176 17.6198 2.28031 19.9998 5.67031 19.9998H14.3403C17.7303 19.9998 20.0003 17.6198 20.0003 14.0898V5.91979C20.0003 2.37979 17.7303 -0.000213623 14.3403 -0.000213623Z",
    fill: "#14AE5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81338 13.2479C8.58938 13.2479 8.36538 13.1629 8.19438 12.9919L5.82138 10.6189C5.47938 10.2769 5.47938 9.72287 5.82138 9.38187C6.16338 9.03987 6.71638 9.03887 7.05838 9.38087L8.81338 11.1359L12.9414 7.00787C13.2834 6.66587 13.8364 6.66587 14.1784 7.00787C14.5204 7.34987 14.5204 7.90387 14.1784 8.24587L9.43238 12.9919C9.26138 13.1629 9.03738 13.2479 8.81338 13.2479Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.8e544c4aaeeb0586ceca518e578b1345.svg";
export { ForwardRef as ReactComponent };